import styled, { css } from 'styled-components';
import { BsFillXCircleFill, BsCheckCircleFill } from 'react-icons/bs';
type ToggleProps = {
  toggled: boolean;
  disabled: boolean;
};
export const Toggle = styled.button<ToggleProps>`
  ${({
  toggled,
  disabled
}) => css`
    border: 0;
    box-sizing: border-box;
    padding: 1px;
    width: 50px;
    height: 24px;
    margin-top: 4px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    background-color: ${disabled ? '#C5C5C5' : toggled ? '#4BAF4F' : '#9C9C9C'};
    border-radius: 12px;
    cursor: ${disabled ? 'unset' : 'pointer'};
    transition: background-color 400ms ease;
  `};
`;
type IconContainerProps = {
  toggled: boolean;
};
export const IconContainer = styled.div<IconContainerProps>`
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  ${({
  toggled
}) => css`
    transform: translateX(${toggled ? '26px' : '0'});
    transition: transform 400ms ease;
  `};
`;
const IconCSS = css`
  width: 22px;
  height: 22px;
  color: #fff;
`;
export const IconDisable = styled(BsFillXCircleFill)`
  ${IconCSS};
`;
export const IconEnable = styled(BsCheckCircleFill)`
  ${IconCSS};
`;